import * as React from 'react';
import { format } from 'date-fns';
import { CalendarIcon } from '@radix-ui/react-icons';
import { cn, isDayDisabled } from '@/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '../shadcn/popover';
import { Button } from '../shadcn/button';
import { Calendar } from '../shadcn/calendar';

type DatePickerProps = {
  createMode?: boolean;
  onChange: (date: Date | undefined) => void;
  sendDate?: Date;
  className?: string;
  displayFormat?: string;
  modifiers?: any;
};

export function DatePicker({
  createMode,
  sendDate,
  onChange,
  className,
  displayFormat,
  modifiers,
}: DatePickerProps) {
  const [date, setDate] = React.useState<Date | undefined>(sendDate);
  const [open, setOpen] = React.useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={'secondary'}
          className={cn(
            'w-[280px] justify-start text-left font-normal text-neutral-900',
            !date && 'text-muted-foreground',
            className
          )}
        >
          <CalendarIcon className='mr-2 h-4 w-4 shrink-0' />
          {date ? (
            format(date, displayFormat || 'PPP')
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0'>
        <Calendar
          modifiers={createMode ? { disabled: isDayDisabled } : modifiers || {}}
          mode='single'
          selected={date}
          onSelect={(date: Date | undefined) => {
            if (date === undefined) {
              return null;
            }

            onChange(date);
            setDate(date);
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
